import {
    SubChartConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/sub-chart-converter';
import type { IRadarChartData } from '@tencent/slide-sdk-model';
import type { IRadarChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';

export class RadarChartConverter extends SubChartConverter {
    public static type = SubChartType.RadarChart;
    public static convertSubChartDataSdkToUi(
        sdkData: IRadarChartData,
        uiData: IRadarChart,
    ) {
        super.convertSubChartDataSdkToUi(sdkData, uiData);

        if (this.isInnerValNotNil(sdkData.radarStyle)) {
            uiData.radarStyle = sdkData.radarStyle.val;
        }
    }

    public static convertSubChartDataUiToSdk(
        uiData: IRadarChart,
        sdkData: IRadarChartData,
    ) {
        super.convertSubChartDataUiToSdk(uiData, sdkData);

        this.convertComplexValueUiToSdk(uiData, 'radarStyle', sdkData, 'radarStyle');
    }
}

